"use client";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./EligibiltyCriteria.css";
import Main_heading_holder from "../../common_components/common_css/main_heading_holder/Main_heading_holder";

const EligibiltyCriteria = ({ spanHeadingColor = "#ad314d" }) => {
  return (
    <section className="Eligibilty-Criteria">
      <Container>

         {/* Heading */}
           <Main_heading_holder
              heading={"Eligibility "}
              spanHeading={" Criteria"}
              spanHeadingColor={spanHeadingColor}
            />

        {/* Content Box */}
            <div className="bg-holder">
              
              <div className="d-flex align-items-start">
                
                {/* Image */}
                <div className="me-3">
                  <img
                    src="/assets/images/spaecialization/Rectangle-img.png"
                    alt="eligibility"
                    className="circle-box"
                  />
                </div>

                {/* Text */}
                <div className="content-holder">
                  <p>
                    Passed any graduation degree (e.g.: B.E. / B.Tech / B.Sc /
                    B.Com / B.A / B.Voc / BCA etc.), preferably with Mathematics
                    at 10+2 or graduation level.
                  </p>
                  <p>
                    Minimum 50% marks (45% for reserved category) in the
                    qualifying examination.
                  </p>
                </div>
              </div>
            </div>
      </Container>
    </section>
  );
};

export default EligibiltyCriteria;